
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4c6.616 0 12 5.384 12 12s-5.384 12-12 12S4 22.616 4 16 9.384 4 16 4zm0 2c-.335 0-.673.03-1 .063v3.031c.327-.047.66-.094 1-.094s.673.046 1 .094V6.063A10.322 10.322 0 0016 6zm-3 .438a9.987 9.987 0 00-6.531 6.563h3.219a7.005 7.005 0 013.313-3.313v-3.25zm6 0v3.25a7.014 7.014 0 013.313 3.313h3.25A10.068 10.068 0 0019 6.438zM16 11c-2.773 0-5 2.227-5 5s2.227 5 5 5 5-2.227 5-5-2.227-5-5-5zm-9.937 4c-.032.326-.063.665-.063 1s.03.673.063 1h3.031A7.013 7.013 0 019 16c0-.337.016-.675.063-1h-3zm16.843 0c.047.327.094.66.094 1s-.046.673-.094 1h3.031c.032-.327.063-.665.063-1s-.03-.673-.063-1h-3.031zM6.438 19a10.068 10.068 0 006.563 6.563v-3.25A7.014 7.014 0 019.688 19h-3.25zm15.875 0A7.014 7.014 0 0119 22.313v3.25A10.068 10.068 0 0025.563 19h-3.25zM15 22.906v3.031c.327.032.665.063 1 .063s.673-.03 1-.063v-3.031c-.327.047-.66.094-1 .094s-.673-.046-1-.094z"}})])
          )
        }
      }
    